<template>
    <div>
        <automation-and-query-maker
            @change="syncQuery($event)"
            :options="options"
            :query="query"
        ></automation-and-query-maker>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            default: () => ({}),
        },
        queries: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            query: this.queries,
        };
    },
    methods: {
        syncQuery($event) {
            this.query = $event;
            this.$emit("change", this.query);
        },
    },
};
</script>
